(function(){
    'use strict';
    angular.module('Directives').directive('bbaLoadingIndicator', bbaLoadingIndicator);
    bbaLoadingIndicator.$inject = [];

    function bbaLoadingIndicator() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaLoadingIndicator.html',
            scope: {
                loadingMessage: '='
            },
            link: bbaLoadingIndicator
        }

        function bbaLoadingIndicator($scope, $element, $attrs) {
            $scope.$watch('loadingMessage', (data) => {
                $scope.loadingTextMessage = data;
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/bbaLoadingIndicator.js